import NoValuesView from './NoValuesView'

export default NoValuesView
